///<reference path="../../../../typings/index.d.ts" />
///<reference path="../../components/baseClasses/dataMaintenanceContextBase.ts"/>
///<reference path="../../components/baseClasses/dataMaintenanceSectionBase.ts"/>
///<reference path="../../components/baseclasses/guid.ts" />
///<reference path="../../components/models/meevo.model.custom.ts" />
///<reference path="../../components/common/security.parts.ts"/>
///<reference path="../employee/employee.context.ts"/>
///<reference path="sections/student.main.section.ts"/>
///<reference path="sections/student.location.section.ts"/>
///<reference path="sections/student.services.section.ts"/>
///<reference path="sections/student.shared.section.ts"/>
///<reference path="sections/student.licensesInsurance.section.ts"/>
///<reference path="sections/student.compensation.section.ts"/>
///<reference path="sections/student.deduction.section.ts"/>
///<reference path="sections/student.bookingRestrictions.section.ts"/>
///<reference path="sections/student.serviceCommissions.section.ts"/>
///<reference path="sections/student.ImageGallery.section.ts"/>
///<reference path="sections/student.notes.section.ts"/>
///<reference path="../../components/models/meevo.dtos.d.ts" />

module Meevo.Plugins.Student {
    import IContextMessages = Meevo.Plugins.Employee.IContextMessages;

    export class StudentContext extends Meevo.Plugins.Employee.EmployeeContext {
        public get baseEndpoint(): string {
            return !this.selectedSection || this.selectedSection && this.selectedSection.sectionId === 0
                ? this.appSettings.API_ENDPOINTS.students
                : this.appSettings.API_ENDPOINTS.employee;
        }

        protected get contextMessages(): IContextMessages {
            return {
                sectionMain: 'SECTION_STUDENTS_MAIN',
                activateUser: 'MESSAGE_ACTIVATE_STUDENT_CONFIRMATION',
                activateUserWithPromo: 'MESSAGE_INACTIVATE_STUDENT_WITH_PROMO_CONFIRMATION',
                clientLinkConfirmation: 'MESSAGE_STUDENT_CLIENT_LINK_CONFIRMATION',
                terminateWithPromo: 'MESSAGE_GRADUATE_STUDENT_WITH_PROMO_CONFIRMATION',
                terminateConfirmation: 'MESSAGE_GRADUATE_STUDENT_CONFIRMATION',
                deleteWithPromoConfirm: 'MESSAGE_DELETE_STUDENT_WITH_PROMO_CONFIRMATION',
                deleteConfirm: 'MESSAGE_DELETE_STUDENT_CONFIRMATION',
                deleteFutureWorkTimeConfirm: 'MESSAGE_DELETE_FUTURE_WORKTIME_CONFIRM_STUDENT',
                deleteFutureBlockTimeConfirm: 'MESSAGE_DELETE_FUTURE_BLOCKTIME_CONFIRM_STUDENT',
                applyTemplateConfirm: 'MESSAGE_CONFIRM_APPLY_TEMPLATE_ON_STUDENT',
                cannotTemplateNew: 'MESSAGE_STUDENT_CANNOT_TEMPLATE_NEW',
            }
        }

        public initializeContext(): void {
            // initialize templatepaths
            this.sectionTemplatePath = 'app/plugins/student/sectionViews/';
        }

        public initializeSections(): void {
            this.initializeContext();
            // Adding sections items that represent areas in the maintenance form
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_STUDENT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0,
                    'SECTION_STUDENTS_MAIN',
                    'main.html',
                    true,
                    false,
                    this.baseEndpoint,
                    '',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.StudentMain,
                    this.appSettings,
                    this.asLocationId,
                    this.securityKeys.DATA_STUDENT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.modalService,
                    null,
                    this
                ));
            } else {
                this.mainTabAccessHide = true;
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_STUDENT_TAB_LOCATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new LocationSection(1,
                    'SECTION_STUDENTS_LOCATIONS',
                    'locations.html',
                    false,
                    false,
                    '',
                    'security',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.StudentSecurity,
                    null,
                    this.securityKeys.DATA_STUDENT_TAB_LOCATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.$translate,
                    this.modalService,
                    this
                ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_STUDENT_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new ServicesSection(2,
                    'SECTION_STUDENTS_SERVICES',
                    'services.html',
                    false,
                    false,
                    '',
                    '',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.StudentServices,
                    this.appSettings,
                    this.securityKeys.DATA_STUDENT_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.securityChecker));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_STUDENT_TAB_PAYROLL + Meevo.Components.Common.SecurityParts.KEY_PART_READ) && !this.identityService.inCentralOfficeMode())
                this.sections.push(new CompensationSection(3,
                    'SECTION_STUDENTS_COMPENSATION',
                    'compensation.html',
                    false,
                    false,
                    '',
                    'compensation',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.StudentCompensation,
                    this.modalService,
                    this.appSettings,
                    this.securityKeys.DATA_STUDENT_TAB_PAYROLL + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_STUDENT_TAB_DEDUCTION + Meevo.Components.Common.SecurityParts.KEY_PART_READ) && !this.identityService.inCentralOfficeMode())
                this.sections.push(new DeductionSection(4,
                    'SECTION_STUDENTS_DEDUCTION',
                    'deduction.html',
                    false,
                    false,
                    '',
                    'deduction',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Model.NounEnum.StudentDeductions,
                    null,
                    this.securityKeys.DATA_STUDENT_TAB_DEDUCTION + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_STUDENT_TAB_SERVICECOMMISSIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new ServiceCommissionsSection(5,
                    "SECTION_STUDENTS_SERVICE_COMMISSIONS_OVERRIDE",
                    "servicesCommissions.html",
                    false,
                    false,
                    '',
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.StudentCommissionOverrides,
                    null,
                    this.securityKeys.DATA_STUDENT_TAB_SERVICECOMMISSIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_STUDENT_TAB_ONLINEBOOKING + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new OnlineBookingSection(6,
                    "SECTION_STUDENTS_ONLINEBOOKING",
                    "OnlineBooking.html",
                    false,
                    false,
                    this.appSettings.API_ENDPOINTS.students,
                    "OnlineBooking",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.StudentOnlineBooking,
                    this.modalService,
                    this.securityKeys.DATA_STUDENT_TAB_ONLINEBOOKING + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_STUDENT_TAB_BOOKINGRESTRICTION + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new BookingRestrictionsSection(7,
                    "SECTION_STUDENTS_BOOKING_RESTRICTIONS",
                    "bookingRestrictions.template.html",
                    false,
                    false,
                    '',
                    'BookingRestrictions',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.StudentBookingRestrictions,
                    this.modalService,
                    this.securityKeys.DATA_STUDENT_TAB_BOOKINGRESTRICTION + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_STUDENT_TAB_LICENSESINSURANCE + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new LicensesInsuranceSection(8,
                    'SECTION_STUDENTS_LICENSE_INSURANCE',
                    'licensesInsurance.html',
                    false,
                    true,
                    '',
                    'licensesinsurances',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.StudentLicenseInsurance,
                    this.modalService,
                    this.securityKeys.DATA_STUDENT_TAB_LICENSESINSURANCE + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_STUDENT_TAB_IMAGEGALLERY + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new ImageGallerySection(9,
                    'SECTION_IMAGE_GALLERY',
                    'imageGallery.html',
                    false,
                    true,
                    '',
                    'imagegallery',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.StudentImageGallery,
                    this.modalService,
                    this.imageGalleryService,
                    this.securityKeys.DATA_STUDENT_TAB_IMAGEGALLERY + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_STUDENT_TAB_NOTES + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new NotesSection(10,
                    'SECTION_CLIENT_NOTES',
                    'notes.html',
                    false,
                    true,
                    '',
                    'notes',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.StudentNotes,
                    this.modalService,
                    this.securityKeys.DATA_STUDENT_TAB_NOTES + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.customDataContextConfig && this.customDataContextConfig.appAreaTabs.length > 0) {
                this.renderCustomSections();
            }
        }

        public selectSection(item): void {

            switch (item.sectionId) {
                case 1:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_STUDENT_TAB_LOCATIONS);
                    break;
                case 2:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_STUDENT_TAB_SERVICES);
                    break;
                case 3:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_STUDENT_TAB_PAYROLL);
                    break;
                case 4:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_STUDENT_TAB_DEDUCTION);
                    break;
                case 5:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_STUDENT_TAB_SERVICECOMMISSIONS);
                    break;
                case 6:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_STUDENT_TAB_ONLINEBOOKING);
                    break;
                case 7:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_STUDENT_TAB_BOOKINGRESTRICTION);
                    break;
                case 8:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_STUDENT_TAB_LICENSESINSURANCE);
                    break;
                case 9:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_STUDENT_TAB_IMAGEGALLERY);
                    break;
                case 10:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_STUDENT_TAB_NOTES);
                    break;
                default:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_STUDENT_TAB_MAIN, true, true);
                    this.loadNotificationSetting();
                    if (this.itemId) {
                        this.loadRating();
                    }
                    break;
            }
            if (this.mainTabAccessHide) {
                this.dataService.getSectionById(this.baseEndpoint, this.itemId, '', this.asLocationId).then((data: Model.Employee) => {
                    this.initializeHeader(data);
                });
                this.mainTabAccessHide = false;
            }
            super.byPassEmployeeSelectSection(item);
        }

        initializeHeader(model: any): void {

            if (!this.isAdding)
                this.headerContent = model.isLocationEmployee ? model.lastName + ', ' + model.firstName : model.userName;

            var canAppendLocationId = !this.isApplicationModeCO() && (this.identityService.current().callCenterId !== this.identityService.current().locationId);

            // Get TenantDistribution model and build url
            this.dataService.customMethodData("api/tenant/businessinfo/customerportalurl", "GET", null)
                .then((result: any) => {
                    if (result && result.data && result.data.onlineBookingUrl) {
                        this.obAppStudentUrl = result.data.onlineBookingUrl;
                    }

                    this.obAppStudentUrl += `&empId=${this.selectedSection.model.id}&empEntityId=${Model.EmployeeEntityTypeEnum.Student}`;
                });
            this.visualizeTabs(model.isLocationEmployee, this.showSharedTab(model));
        }

        public visualizeTabs(isLocationEmployee: boolean, showSharedTab: boolean): void {
            let employee = <Model.Employee>this.selectedSection.model;

            this.sections.forEach(s => {
                if (s.noun === null && !employee.security.userLocations[0].location.isEmployee) {
                    s.isVisible = false;
                }
                switch (s.displayNameContentKey) {
                    case 'SECTION_STUDENTS_SERVICES':
                    case 'SECTION_STUDENTS_LICENSE_INSURANCE':
                    case 'SECTION_STUDENTS_COMPENSATION':
                    case 'SECTION_STUDENTS_DEDUCTION':
                    case 'SECTION_STUDENTS_BOOKING_RESTRICTIONS':
                    case 'SECTION_STUDENTS_SERVICE_COMMISSIONS_OVERRIDE':
                    case 'SECTION_IMAGE_GALLERY':
                    case 'SECTION_CLIENT_NOTES':
                        s.isVisible = isLocationEmployee;
                        break;
                    case 'SECTION_STUDENT_SHARED':
                        s.isVisible = showSharedTab;
                        break;
                }
            });

        }

        public openTerminateEditor(context: StudentContext, employee: Model.Employee) {
            // Initialize modal with employee resources
            const options: Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/student/sectionViews/terminateTemplate.html',
                clickOutsideToClose: false,
                locals: {
                    context: context,
                    employee: employee
                },
                controller: 'meevo.plugins.student.TerminateStudentController',
                controllerAs: 'vm'
            };
            this.modalService.showCustom(options);
        }

        private _obAppStudentUrl: string = '';

        get obAppStudentUrl(): string {
            return this._obAppStudentUrl;
        }
        set obAppStudentUrl(value: string) {
            this._obAppStudentUrl = value;
        }
    }
}
